<template>
    <div></div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  created: function () {
    if (this.activeId) {
      this.$router.push({ name: 'Cards', params: { id: this.activeId } })
    }
  },
  computed: {
    ...mapGetters([
      'activeId'
    ])
  },
  watch: {
    activeId: function () {
      this.$router.push({ name: 'Cards', params: { id: this.activeId } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue